export default {
  path: 'programs',
  component: () => import('@/views/artist/gcp/GcpPage.vue'),
  children: [
    {
      path: '',
      name: 'artist-gcp-list',
      meta: {
        title: 'program.gcp',
      },
      component: () => import(
        /* webpackChunkName "artist-gcp-list" */
        '@/views/artist/gcp/GcpList.vue'
      ),
    },
    {
      path: 'gcp/:programId',
      name: 'artist-gcp-program',
      meta: {
        title: 'program.gcp',
      },
      component: () => import(
        /* webpackChunkName: "artist-programs-gcp" */
        '@/views/artist/gcp/GcpProgram.vue'
      ),
    },
  ],
};
